// Direct visits to the full shop show newly added products first. Explicit
// customer sorting, filters, pagination and locale-aware paths stay intact.
const shopUrl = new URL(window.location.href);
if (!shopUrl.searchParams.has('sort_by')) {
    shopUrl.searchParams.set('sort_by', 'created-descending');
    window.location.replace(shopUrl.toString());
}
